export default __webpack_public_path__ + "static/media/bo-gia-16146819941008.ed376bdc.png";